function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.apply = this.querySelector(".filters__apply");
    this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 500);
    this.apply.addEventListener("click", this.debouncedOnSubmit.bind(this));
    this.addFakeSelectListener();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('is-loading');

    if (countContainer) countContainer.classList.add('is-loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderPagination(html);
        FacetFiltersForm.renderSort(html);
        FacetFiltersForm.syncScrollBars();

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderSort(html);
    FacetFiltersForm.syncScrollBars();
  }

  static renderProductGridContainer(html) {
    const columns = document.querySelector(".js-product-grid").classList.contains("double");
    const gridContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');

    if (columns) {
      const gridItems = gridContainer.querySelectorAll(".js-product-grid .column");

      gridItems.forEach((item) => {
        item.classList.replace('is-12-mobile', 'is-6-mobile');
      });

    }

    document.getElementById('ProductGridContainer').innerHTML = gridContainer.innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');

    container.innerHTML = count;
    container.classList.remove('is-loading');
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );

    facetDetailsElements.forEach((el, i) => {
      document.querySelectorAll('#FacetFiltersForm .js-filter')[i].innerHTML = el.innerHTML;
    });

    // const matchesIndex = (element) => {
    //   const jsFilter = event ? event.target.closest('.js-filter') : undefined;

    //   return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    // };

    // const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    // const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    // facetsToRender.forEach((element) => {
    //   const facet = element.querySelector(".filters__list");
    //   const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"] .filters__list`);

    //   if (target && facet) target.innerHTML = facet.innerHTML;
    // });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    // if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static syncScrollBars() {
    if (window.theme && typeof theme.scrollBar === 'function') {
      theme.scrollBar();
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.filters__refinements'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static renderPagination(html) {
    let pagination = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.js-pagination');
    let domPagination = document.querySelectorAll('.pagination-container');

    if (pagination.length > 0) {
      pagination.forEach((el, i) => {
        if (el) {
          domPagination[i].innerHTML = el.outerHTML;
        }
      });
    } else {
      domPagination.forEach(el => {
        el.innerHTML = "";
      });
    }
  }

  static renderSort(html) {
    const content = new DOMParser().parseFromString(html, 'text/html');
    const selectLabel = content.querySelector(".filters__label strong");
    const oldLabel = document.querySelector(".filters__label strong");
    const selectDesktop = content.querySelectorAll('.select .select__dropdown .select__item');
    const oldDesktop = Array.from(document.querySelectorAll('.select .select__dropdown .select__item'));

    oldLabel.innerHTML = selectLabel.innerHTML;

    FacetFiltersForm.updateOptions(selectDesktop, oldDesktop);
  }

  static updateOptions(options, oldOptions) {
    options.forEach(option => {
      const oldOption = oldOptions.find(oldOption => oldOption.dataset.value === option.dataset.value);

      if (oldOption) oldOption.classList = option.classList;
    });
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);

    if (window.innerWidth <= 749) {
      const filterDrawer = event.target.closest('filters-drawer');
      if (filterDrawer) {
        filterDrawer.toggleDrawer();
      }
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.target.className === 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));

      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');

            noJsElements.forEach((el) => el.remove());

            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    const href = event.currentTarget.href;
    const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }

  addFakeSelectListener() {
    const selects = [".filters__select", ".pagination__select"];

    selects.forEach(input => {
      const select = document.querySelector(input);

      if (!select) return;

      const dropdown = select.querySelector(".select__dropdown");
      const options = select.querySelectorAll("li");
      const label = select.querySelector(".filters__label") || select.querySelector(".pagination__label");

      if (label) label.addEventListener("click", () => dropdown.classList.toggle("select__dropdown--active"));

      options.forEach(option => option.addEventListener("click", event => {
        this.updateSelect(event);

        if (dropdown) dropdown.classList.remove("select__dropdown--active");
      }));

      window.addEventListener("click", event => {
        if (!select.contains(event.target) && dropdown?.classList.contains("select__dropdown--active")) {
          dropdown.classList.remove("select__dropdown--active");
        }
      });
    });
  }

  updateSelect(event) {
    const select = this.querySelector("select");
    const options = Array.from(select.querySelectorAll("select option"));
    const selected = event.target.dataset.value;
    const selectedOption = options.find(option => option.value === selected);

    if (selectedOption) select.value = selectedOption.value;

    this.onSubmitHandler(event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();

customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
